import {is3dVisualizer, IVisualizerManager} from "../../visualizers/VisualizerContext";
import {IVisualizerStatus} from "./VscVisualizerSession";
import {IHouseModelSetting, ILotLabel, IParking} from "../../unreal/BigScreenCommunity3D";
import {IOptionSetRequest} from "../../unreal_api/UnrealClient";
import {IMessageSender} from "../../visualizers/UnrealSignalRVisualizer";

import {IViewpoint} from "../../data/IViewpoint";

export interface ILevelGroupSetting {
    lot: string;
    levelGroup: string;
}
// plan => configuring a house

export type IShow3DMode = "plan" | "sitespecific" | "community";
export interface IBaseShow3DOptions {
    //camera: string; TODO
    levelGroups?: ILevelGroupSetting[];
    lotLabels?: ILotLabel[];
    parking?: IParking[];
    houseModels?: IHouseModelSetting[];
    map?: string;
}

export interface IShow3DPlanOptions extends IBaseShow3DOptions {
    mode: "plan";
}
export interface IShow3DSiteSpecificOptions extends IBaseShow3DOptions {
    mode: "sitespecific";
}

export interface IShow3DCommunityOptions extends IBaseShow3DOptions {
    mode: "community";

}
export type IShow3DOptions = IShow3DCommunityOptions | IShow3DPlanOptions | IShow3DSiteSpecificOptions;



export class VisualizerSessionManager {
    constructor(private readonly onSetStatus: (status: IVisualizerStatus) => void, private readonly visualizer: IVisualizerManager) {



    }
    clearStatus() {
        this.onSetStatus({sessionId: "CLEAR", details: { type: "3d"}})
    }
    connect() {
        return this.visualizer.connect();
    }

    getMessageSender() {
        return this.visualizer.getMessageSender();
    }

    /*
    This loads a video to the video player session
     */
    loadVideo(sessionId: string, file: string, title: string, looping: boolean) {
        this.onSetStatus({sessionId: sessionId, details: {type: "video", isPlaying: true, file, title, looping}});
        this.visualizer.playVideo(sessionId, file, looping);

    }

    changeCamera(cameraId:string) {
        this.visualizer.changeCamera(cameraId);
    }

    changeCameraToViewpoint(viewpoint: IViewpoint, relativeTo?: string) {

        this.visualizer.changeCameraToViewpoint(viewpoint, relativeTo);
    }

    browse(sessionId: string, url: string) {
        this.onSetStatus({sessionId: sessionId, details: {type: 'web'}});
        this.visualizer.browse(sessionId, url);
    }

    show3d(sessionId:string, options: IShow3DOptions) {
        console.log('show 3d, session ' + sessionId);
        const vis = this.visualizer;

        this.onSetStatus({sessionId: sessionId, details: { type: "3d"}});
        if (!is3dVisualizer(vis)) {
            //throw "Unable to show 3D";
            return;
        }
        vis.show3d(sessionId, options);

    }

    sendOptions(req: IOptionSetRequest) {
        return this.visualizer.sendOptions(req);


    }

    // Admin / request information on the open map
    requestMapInfo() {
        return this.visualizer.requestMapInfo();
    }
}

export default VisualizerSessionManager;
